import React, { useState, useEffect } from "react";
import axios from "axios";
import { Chart } from "react-google-charts";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

// component
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from "components/Card/CardHeader";
import Button from 'components/CustomButtons/Button.js'

import styles from 'views/component/Styles.js';
import tableStyles from "assets/jss/material-dashboard-pro-react/components/tableStyle";

import SimpleTable from "views/component/SimpleTable";
import ReqPopup from "./tables/ReqPopup";
import SolutionPopup from "./Solution";
import { Check } from "@material-ui/icons";
import ToggleInput from "views/component/ToggleInput";
import CustomInput from "components/CustomInput/CustomInput";

const useStyles = makeStyles(styles);
const useTableStyles = makeStyles(tableStyles);

export default function APSResultView(props) {
    const { factory } = props;
    const classes = useStyles();
    const tableClasses = useTableStyles();

    const [reqSelected, setReqSelected] = useState([]);
    const [reqPop, setReqPop] = useState(false);
    const [requestInfo, setRequestInfo] = useState([]);
    const [requestResult, setRequestResult] = useState([]);
    const [updateTime, setUpdateTime] = useState();
    const [filterDate, setFilterDate] = useState('');

    const timelineColor = ['#3366cc', '#ff9900', '#109618', '#dd4477', '#aaaa11', '#990099', '#0099c6', '#66aa00', '#b82e2e',
        '#316395', '#994499', '#22aa99', '#dc3912', '#6633cc', '#e67300', '#8b0707', '#651067', '#329262', '#5574a6', '#3b3eac',
        '#b77322', '#16d620', '#b91383', '#f4359e', '#9c5935', '#a9c413', '#2a778d', '#668d1c', '#bea413', '#0c5922', '#743411',];
    const [timelineData, setTimelineData] = useState({});
    const [timelineHeight, setTimelineHeight] = useState(0);
    const [detailPop, setDetailPop] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [selectedIndex2, setSelectedIndex2] = useState();

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        const selects = reqSelected.filter(item => !!item && !timelineData[item.request_id]);
        if (selects.length !== 0) {
            axios.all(selects.map(item => (
                axios.get('aps/list/solution', { params: { ...factory, 'request_id': item.request_id, 'order by': 'machine_id,start_time' } })
            ))).then(responseList => {
                let temp = { ...timelineData };
                responseList.forEach((response, index) => {
                    if (response.data.data.length === 0) {
                        alert('완료되지 않은 요청입니다');
                        return;
                    } else {
                        temp[response.config.params.request_id] = response.data.data;
                    }
                });
                setTimelineData(temp);
            });
        }
    }, [reqSelected]);

    const getList = function () {
        axios.get('aps/list/requestInfo', { params: { ...factory, 'order by': 'request_time desc' } }).then(response => {
            setRequestInfo(response.data.data);
            const tempTime = new Date();
            setUpdateTime(new Date(tempTime.getTime() - tempTime.getTimezoneOffset() * 60000).toISOString());
        });
        axios.get('aps/list/requestResult', { params: { ...factory, 'order by': 'request_time desc' } }).then(response => {
            setRequestResult(response.data.data);
        });
    }

    const handleAdd = function () {
        setReqPop(true);
    }
    const getChartData = function (data) {
        if (data) {
            if (!timelineHeight) {
                setTimelineHeight(Array.from(new Set(data.map(item => item.machine_id))).length * 41 + 50);
            }
            return [[
                { type: 'string', id: 'machine' }, { type: 'string', id: 'product' }, { type: 'string', role: 'tooltip' },
                { type: 'date', id: 'Start' }, { type: 'date', id: 'End' },
            ], ...data.map(item => ([
                item.machine_id, item.product_id, '<b>' + item.product_id + '</b><br/>' + item.start_time + ' ~ ' + item.end_time,
                new Date(item.start_time), new Date(item.end_time)
            ]))];
        }
        return undefined;
    }
    const getTimelineColor = function (data) {
        const productList = [...new Set(data.map(item => item.product_id))].sort();
        let colors = data.map(item => timelineColor[productList.indexOf(item.product_id)]);
        return [...new Set(colors)];
    }

    const onListRowClick = function (rowIndex) {
        if (rowIndex === selectedIndex2) {
            setSelectedIndex2();
        } else if (rowIndex === selectedIndex) {
            setSelectedIndex();
        } else if (isNaN(selectedIndex)) {
            setSelectedIndex(rowIndex);
        } else if (isNaN(selectedIndex2)) {
            setSelectedIndex2(rowIndex);
        }
    }
    useEffect(() => {
        if (requestInfo) {
            setReqSelected([requestInfo[selectedIndex], requestInfo[selectedIndex2]]);
        }
    }, [requestInfo, selectedIndex, selectedIndex2]);

    useEffect(() => {
        const timer = setInterval(() => {
            getList();
        }, 30000);
        return () => clearInterval(timer);
    }, []);

    const tableCellClasses = tableClasses.tableHeadCell + " " + tableClasses.tableCell;
    return (
        <GridContainer style={{ padding: '30px 10px' }}>
            <GridItem md={12} xs={12} key={'requestInfo'}>
                <Card>
                    <CardHeader>
                        <div className={classes.right}>
                            <CustomInput labelText='요청일' underlineColor='info'
                                inputProps={{ type: 'date', value: filterDate, onChange: (e) => { setFilterDate(e.target.value) } }}
                                labelProps={{ shrink: true }}
                            />
                            <Button color="info" className={classes.right} size="sm" onClick={handleAdd}
                                style={{ marginLeft: '30px', marginTop: '30px' }}>신규 요청</Button>
                        </div>
                        <h4><b>요청 목록</b></h4>
                        <h6>{updateTime}</h6>
                    </CardHeader>
                    <CardBody>
                        <Table className={tableClasses.table}>
                            <TableHead className={tableClasses['gray']}>
                                <TableRow
                                    className={tableClasses.tableRow + " " + tableClasses.tableRowHead + " " + tableClasses.tableHeadFontSize}>
                                    <TableCell className={tableCellClasses} key='request_id'> 요청 ID </TableCell>
                                    <TableCell className={tableCellClasses} key='optimizerType'> 최적화 타입 </TableCell>
                                    <TableCell className={tableCellClasses} key='optimizerTime'> 최적화 시간 </TableCell>
                                    <TableCell className={tableCellClasses} key='balancingFlag'> 벨런싱 반영 </TableCell>
                                    <TableCell className={tableCellClasses} key='settingFlag'> 셋팅 반영</TableCell>
                                    <TableCell className={tableCellClasses} key='movingDelayFlag'> 공정 간 이동시간 반영</TableCell>
                                    <TableCell className={tableCellClasses} key='result'> 요청상태</TableCell>
                                    <TableCell className={tableCellClasses} key='makespan'> 최대생산시간</TableCell>
                                    <TableCell className={tableCellClasses} key='message'> 비고</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {requestInfo.filter(row => row['request_id'].includes(filterDate.replace(/-/g, ''))).length === 0 ? (
                                    <TableRow>
                                        <TableCell className={tableClasses.tableCell} colSpan={9}>데이터가 없습니다 </TableCell>
                                    </TableRow>
                                ) : null}
                                {requestInfo.filter(row => row['request_id'].includes(filterDate.replace(/-/g, ''))).map((row, rowIndex) => {
                                    var rowColor = "";
                                    var rowColored = false;
                                    if (rowIndex === selectedIndex) {
                                        rowColor = 'info';
                                        rowColored = true;
                                    } else if (rowIndex === selectedIndex2) {
                                        rowColor = 'warning';
                                        rowColored = true;
                                    }
                                    const tableRowClasses = cx({
                                        [tableClasses.tableRow]: true,
                                        [tableClasses.tableRowBody]: true,
                                        [tableClasses.tableRowHover]: true,
                                        [tableClasses[rowColor + "Row"]]: rowColored,
                                    });
                                    const requestVal = JSON.parse(row['request_val'].value);
                                    const result = requestResult.
                                        filter(item => item.request_id === row.request_id).
                                        map(item => JSON.parse(item.result_val.value))[0];
                                    return (
                                        <TableRow key={rowIndex} hover className={tableRowClasses}
                                            onClick={(e) => { onListRowClick(rowIndex) }}>
                                            <TableCell className={tableClasses.tableCell} key='request_id'>
                                                {row['request_id']}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='optimizerType'>
                                                {['단순배치', 'Rule', 'Optimizer'][requestVal['optimizerType']]}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='optimizerTime'>
                                                {requestVal['optimizerTime']}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='balancingFlag'>
                                                {requestVal['balancingFlag'] ?
                                                    <Check className={classes.checkedIcon} /> :
                                                    <Check className={classes.uncheckedIcon} />}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='settingFlag'>
                                                {requestVal['settingFlag'] ?
                                                    <Check className={classes.checkedIcon} /> :
                                                    <Check className={classes.uncheckedIcon} />}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='movingDelayFlag'>
                                                {requestVal['movingDelayFlag'] ?
                                                    <Check className={classes.checkedIcon} /> :
                                                    <Check className={classes.uncheckedIcon} />}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='result'>
                                                {result ? result['result'] : '요청중'}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='makespan'>
                                                {result?.['makespan']}
                                            </TableCell>
                                            <TableCell className={tableClasses.tableCell} key='message'>
                                                {result?.['message']}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </CardBody>
                </Card>
            </GridItem>
            {reqSelected.filter(item => !!item && timelineData[item.request_id]).map(req => {
                const result = requestResult.filter(item => item.request_id === req.request_id).map(item => JSON.parse(item.result_val.value))[0];
                return <GridItem md={12} xs={12} key={req.request_id}>
                    <SolutionPopup factoryId={factory.factory_id} requestId={req.request_id}
                        modal={detailPop} onClose={() => setDetailPop(false)} />
                    <Card>
                        <CardHeader>
                            <Button size="sm" color="infoOutline" className={classes.right}
                                onClick={e => { setDetailPop(true); }}>상세보기</Button>
                            <h4 style={{ display: 'inline', marginRight: 20 }}>
                                <b>{req.request_id}</b>
                            </h4>
                            <h6>{Object.keys(result).filter(key => key !== 'requestId').map(key => key + ' : ' + result[key]).join(', ')}</h6>
                        </CardHeader>
                        <CardBody>
                            <Chart chartType="Timeline" loader={<div>Loading Chart</div>}
                                data={getChartData(timelineData[req.request_id])} options={{
                                    colors: getTimelineColor(timelineData[req.request_id]),
                                    height: timelineHeight,
                                    tootip: { isHtml: true },
                                    hAxis: { format: 'YYYY-MM-dd HH', }
                                }}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            })}
            <ReqPopup factory={factory} modal={reqPop} onClose={() => setReqPop(false)} onSave={() => getList()} />
        </GridContainer>
    );
}